import React, { lazy, Suspense } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

const LoadedComponent = lazy(() => import('../drive/Drive'));

export default () => <Suspense fallback={<LinearProgress />}>
      <LoadedComponent />
</Suspense>
